/**
 * Constants for Dev Mode features
 */

export const DEV_MODE_PASSWORD = 'devmode2024';
export const DEV_SWITCHER_REQUIRED_CLICKS = 5;
export const DEV_SWITCHER_CLICK_RESET_TIMEOUT = 2000; // milliseconds

